import React from "react";
import Spinner from "../../../components/utilities/Spinner";

const LoadingPage = () => <Spinner />;

export default LoadingPage;
